export { default } from "./tasksLogs.inner";
